@if (errorService.serverError(); as serverError) {
	<error-page [status]="serverError" (logout)="logout()"></error-page>
} @else {
	<div id="body" class="app {{ pageName() }}">
		@if (!displayMode()) {
			<ui-nav
				class="hide-mobile"
				[items]="desktopMenuPoints()"
				[apps]="appNavMenuPoints()"
				[activeApp]="activeApp"
				[environment]="environment"
				[currentUrl]="currentUrl()"
				(callbackEvent)="navCallback($event)"
				[navTranslations]="{
					beta: ('general.beta' | translate),
					apps: ('general.apps' | translate),
				}"
			>
			</ui-nav>
		}
		<div class="body" [class.is-display]="displayMode()">
			<router-outlet></router-outlet>
			@if (error()) {
				<ui-overlay
					(closeOverlay)="onClose()"
					[showCloseButton]="true"
					[header]="error().type + '.header' | lowercase | translate"
				>
					<ui-error-content
						[emailExtras]="emailExtras()"
						[error]="error()"
						(closed)="onClose()"
					></ui-error-content>
				</ui-overlay>
			}
		</div>

		<ui-mobile-nav
			class="hide-desktop"
			[items]="mobileMenuPoints()"
			[apps]="appNavMenuPoints()"
			[activeApp]="activeApp"
			[environment]="environment"
			[currentUrl]="currentUrl()"
			(callbackEvent)="navCallback($event)"
			[hidden]="displayMode()"
			[navTranslations]="{
				beta: ('general.beta' | translate),
				apps: ('general.apps' | translate),
			}"
		></ui-mobile-nav>
	</div>

	@if (helpOpen) {
		<ui-overlay [header]="'help_overlay.title' | translate" (closeOverlay)="onCloseHelp()">
			<ui-help-content (closed)="onCloseHelp()"></ui-help-content>
		</ui-overlay>
	}

	@if (summaryOpen()) {
		<summary-of-the-year></summary-of-the-year>
	}

	@if (!onBoardingWatched()) {
		<ui-onboarding
			headline="onboarding.headline"
			[slides]="analyticsOnboarding"
			[size]="Sizes.XL"
			[showCloseButton]="true"
			(onboardingWatched)="setOnboardingToWatched()"
		></ui-onboarding>
	}
	<toast-container></toast-container>
	<cookie-overlay></cookie-overlay>
}
